/* eslint-disable */

import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { useHistory } from "react-router-dom";

export function ValueModal({ isOpen, onClose }) {
  const { control } = useForm();
  const [errorMessage, setErrorMessage] = useState(null);
  const [valueRecharge, setValueRecharge] = useState(100);
  const [valueFloat, setValueFloat] = useState('100,00');
  const history = useHistory();

  if (!isOpen) return null;

  const isEven = (v) =>
    parseFloat(
      v.replaceAll('R$ ', '').replaceAll('.', '').replaceAll(',', ''),
      10
    ) > 0;

  const handleConfirm = () => {
    const amount = valueFloat.replaceAll(',', '').replaceAll('.', '');
    if (amount >= 500) {
      localStorage.setItem('amount', JSON.stringify(amount));
      window.location.href = '/recharge';
      onClose();
    }
  };

  return (
    <div className="value-modal__backdrop">
      <div className="modal-winn">
        <label className="modal-label">
          Digite o valor da recarga
        </label>


        <div className="input-wrapper">
          <div className="account-col payment_inf">
            <div className="form">
              <div
                className="form__form-group"
                style={{ marginBottom: '0px', width: 'fit-content' }}
              >
                <div className="form__form-group-field">
                  <Controller
                    name="amount"
                    rules={{
                      required: 'Este campo é obrigatório.',
                      validate: isEven
                    }}
                    control={control}
                    render={({
                      field: { onChange, onBlur, ref }
                    }) => (
                      <NumericFormat
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        fixedDecimalScale
                        prefix="R$ "
                        placeholder="R$ 0,00"
                        className="input-info-payment"
                        allowNegative={false}
                        value={valueRecharge}
                        onValueChange={(values) => {
                          onChange(values.floatValue);
                          if (values.floatValue > 0) {
                            if (values.floatValue < 5)
                              setErrorMessage(
                                'O Valor mínimo de recarga é R$ 5,00'
                              );
                            else setErrorMessage(null);
                            setValueRecharge(
                              values.floatValue
                                .toFixed(2)
                                .replace('.', ',')
                            );
                            setValueFloat(
                              values.floatValue
                                .toFixed(2)
                                .replace('.', ',')
                                .replace('R$ ', '')
                            );
                          } else {
                            setErrorMessage(
                              'O Valor mínimo de recarga é R$ 5,00'
                            );
                            setValueFloat('0,00');
                            setValueRecharge(0);
                          }
                        }}
                        onBlur={onBlur}
                        getInputRef={ref}
                      />
                    )}
                  />
                </div>
                {errorMessage && (
                  <span className="error">{errorMessage}</span>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="modal-actions">
          <button
            className="btn-modal-cancel"
            onClick={onClose}
          >
            Cancelar
          </button>

          <button
            className="btn-modal"
            disabled={errorMessage}
            onClick={handleConfirm}
          >
            Prosseguir
          </button>
        </div>
      </div>
    </div>
  );
}